import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { tap, map, take } from 'rxjs/operators';
import { ErrorService } from './error.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
    private errorService: ErrorService,
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.auth.user$.pipe(
      take(1),
      map(user => !!user && !!user.status), // <-- map to boolean
      tap(loggedIn => {
        if (!loggedIn) {
          this.errorService.errorMgmt(new Error('Access denied'), 'authguard', false)
          this.router.navigate(['/login']).catch();
        }
      })
    )
  }
}